/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FilterItem } from './';
import {
    FilterItemFromJSON,
    FilterItemFromJSONTyped,
    FilterItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdminFilters
 */
export interface AdminFilters {
    /**
     * 
     * @type {Array<FilterItem>}
     * @memberof AdminFilters
     */
    filters: Array<FilterItem>;
}

/**
 * Check if a given object implements the AdminFilters interface.
 */
export function instanceOfAdminFilters(value: object): value is AdminFilters {
    if (!('filters' in value) || value['filters'] === undefined) return false;
    return true;
}

export function AdminFiltersFromJSON(json: any): AdminFilters {
    return AdminFiltersFromJSONTyped(json, false);
}

export function AdminFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminFilters {
    if (json == null) {
        return json;
    }
    return {
        
        'filters': ((json['filters'] as Array<any>).map(FilterItemFromJSON)),
    };
}

export function AdminFiltersToJSON(value?: AdminFilters | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'filters': ((value['filters'] as Array<any>).map((v) => FilterItemToJSON(v))),
    };
}

